import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  ActiveFlowsChanged,
  ClearSearchFlowsOptions,
  DeactivatedFlowsChanged,
  FlowContextChanged,
  FlowNameChanged,
  GetFlowsSuccess,
  GetFlowsTemplateSuccess,
  PanelStatusChanged,
} from '../actions/search-flows.actions';
import { SearchFlowsState } from '../models/flows.model';

const initialState: SearchFlowsState = {
  templateProperties: [],
  panelExpanded: true,
  flowName: '',
  flowContextValues: [],
  flowContext: '',
  activeFlows: true,
  deactivatedFlows: false,
};

export const SearchFlowsReducer = createReducer(
  initialState,
  on(GetFlowsSuccess, (state, { res }) => ({
    ...state,
    flowContextValues: res.payload.data,
  })),
  on(GetFlowsTemplateSuccess, (state, { res }) => ({
    ...state,
    templateProperties: res.payload.data,
  })),
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(FlowContextChanged, (state, { flowContext }) => ({
    ...state,
    flowContext: flowContext ?? '',
  })),
  on(FlowNameChanged, (state, { flowName }) => ({
    ...state,
    flowName,
  })),
  on(ActiveFlowsChanged, (state) => ({
    ...state,
    activeFlows: !state.activeFlows,
  })),
  on(DeactivatedFlowsChanged, (state) => ({
    ...state,
    deactivatedFlows: !state.deactivatedFlows,
  })),
  on(ClearSearchFlowsOptions, (state) => ({
    ...state,
    flowName: '',
    flowContext: '',
    activeFlows: true,
    deactivatedFlows: false,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) => {
    if (activeComponent === 'FlowsSearchComponent' || 'FlowConfigurationComponent')
      return {
        ...state,
        panelExpanded: true,
        tagType: '',
        tagCode: '',
        tagLabel: '',
        searchAvailable: false,
      };

    return initialState;
  }),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
